/*
  OFFE - solid colour swatches on the product page and in Quick View
  (Rachel, Oct 27, 2026). Swatches that showed a photo (colour siblings
  without a known colour name, and colour variants that use the variant
  photo) become a flat colour:
    1. the colour name (same word list as snippets/offe-swatch-color.liquid;
       "Black/White" gives a half-and-half dot, "Multi"/"Print" a rainbow)
    2. otherwise the main colour of that colour's photo (sampled here)
  Product cards are not touched. Styles: assets/offe-solid-swatches.css.
*/
(function () {
  var MAP = 'black:#1b1b1b,jet:#1b1b1b,onyx:#1b1b1b,noir:#1b1b1b,charcoal:#3b3b3b,graphite:#4a4a4a,grey:#8e8e8e,gray:#8e8e8e,heather:#a3a3a3,smoke:#9a9a9a,ash:#b5b5b5,silver:#c3c4c7,steel:#6f7c8a,slate:#5f6b75,white:#ffffff,optic:#ffffff,ivory:#f6f1e1,cream:#f3ecd8,ecru:#e9e1cc,natural:#e6dac2,bone:#e8e0cf,oat:#d8cbb3,oatmeal:#d8cbb3,vanilla:#f3e5c0,beige:#d9c7a7,sand:#d6c4a1,stone:#b9b1a3,taupe:#8b7d70,khaki:#b9ad85,tan:#c8a27a,camel:#b98a57,nude:#d9b49b,caramel:#b26f32,cognac:#9a4a24,toffee:#9b6a3c,brown:#7a5232,chocolate:#4e3020,mocha:#6f4e37,cocoa:#5c3d2e,coffee:#6f4e37,espresso:#3c2a21,walnut:#5c4033,leopard:#c49a5a,rust:#a3471f,terracotta:#c0603e,clay:#b8735a,sienna:#a0522d,orange:#ee7a2b,tangerine:#f28c28,peach:#f6b38f,apricot:#f3a96b,coral:#f17a6a,salmon:#f08a75,red:#c62828,scarlet:#c62828,cherry:#a3162b,tomato:#d9452f,burgundy:#6d1a2b,bordeaux:#5e1626,wine:#6b1f2f,oxblood:#4f1418,maroon:#5a1a22,pink:#f2a7bd,blush:#efc3c4,rose:#d98a96,mauve:#b5838d,magenta:#c2185b,fuchsia:#d81b8c,berry:#8e2a52,raspberry:#b3245a,purple:#6b3fa0,lilac:#c8b6e2,lavender:#c4b5e6,violet:#7e57c2,orchid:#b07cc6,plum:#5a2a4a,grape:#5b2d6e,blue:#3f6fc6,navy:#1f2a44,midnight:#1c2340,royal:#2747a8,cobalt:#1f4fbf,sky:#9ccbee,baby:#a9cfee,powder:#b8d4ea,indigo:#34407a,denim:#4a6489,chambray:#7d93b2,teal:#1f7a7a,turquoise:#3cc0c0,aqua:#5fd0d0,mint:#a8dcc0,sage:#a3b18a,seafoam:#9fd6c2,olive:#6b6b2f,green:#3f8a4a,kelly:#2e9d4a,forest:#234d2e,hunter:#2c5234,emerald:#1f7a4f,jade:#3a9b77,moss:#6b7a3a,pistachio:#b6cf8e,lime:#bebe41,chartreuse:#b7c736,yellow:#f2d03b,lemon:#f6e27a,butter:#f4e3a1,mustard:#d4a52a,gold:#c9a43a,honey:#d6a243,bronze:#9c6b30,copper:#b06a3b,brass:#b5a642,pewter:#8e9196,mist:#cfd8dc,dusk:#6d6a8a,rainforest:#2f5d3a,comet:#5d6a85,palace:#2d3f8f,dew:#c9e2da';
  var COLORS = {};
  MAP.split(',').forEach(function (p) { var kv = p.split(':'); COLORS[kv[0]] = kv[1]; });
  var MULTI = { multicolor: 1, multicolour: 1, multi: 1, rainbow: 1, print: 1, assorted: 1, mixed: 1 };
  var RAINBOW = 'conic-gradient(#e2574c, #f2c94c, #6fbf73, #56b4e9, #9b6cd6, #e2574c)';

  function fromName(name) {
    if (!name) return null;
    var n = name.toLowerCase().replace(/&| and |\+| with /g, '/');
    var found = [], multi = false;
    n.split('/').slice(0, 2).forEach(function (half) {
      var words = half.replace(/[-,().]/g, ' ').split(/\s+/).filter(Boolean).reverse();
      for (var i = 0; i < words.length; i++) {
        if (MULTI[words[i]]) { multi = true; return; }
        if (COLORS[words[i]]) { found.push(COLORS[words[i]]); return; }
      }
    });
    if (found.length === 1) return found[0];
    if (found.length > 1) return 'linear-gradient(135deg, ' + found[0] + ' 50%, ' + found[1] + ' 50%)';
    if (multi) return RAINBOW;
    return null;
  }

  /* Main colour of a photo: drop the background (corner colour) and
     near-white, then skin tones (when enough garment is left), then take
     the biggest colour group. */
  function sample(src, done) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var S = 48, canvas = document.createElement('canvas');
        canvas.width = S; canvas.height = S;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, S, S);
        var d = ctx.getImageData(0, 0, S, S).data;
        var px = function (i, j) { var k = (j * S + i) * 4; return [d[k], d[k + 1], d[k + 2]]; };
        var cs = [px(0, 0), px(S - 1, 0), px(0, S - 1), px(S - 1, S - 1)];
        var bg = [0, 1, 2].map(function (k) { return (cs[0][k] + cs[1][k] + cs[2][k] + cs[3][k]) / 4; });
        var all = [];
        for (var j = 3; j < S - 3; j++) {
          for (var i = 3; i < S - 3; i++) {
            var p = px(i, j);
            if (Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]) < 60) continue;
            if (p[0] > 235 && p[1] > 235 && p[2] > 235) continue;
            all.push(p);
          }
        }
        var skin = function (p) {
          var r = p[0], g = p[1], b = p[2];
          return r > 95 && g > 40 && b > 20 && r > g && r > b && (r - g) > 15 && (r - b) > 30 &&
            (Math.max(r, g, b) - Math.min(r, g, b)) > 15;
        };
        var rest = all.filter(function (p) { return !skin(p); });
        var use = rest.length >= all.length * 0.15 ? rest : all;
        if (!use.length) return done('rgb(' + bg.map(Math.round).join(',') + ')');
        var bins = {};
        use.forEach(function (p) {
          var key = (p[0] >> 5) + ',' + (p[1] >> 5) + ',' + (p[2] >> 5);
          (bins[key] = bins[key] || []).push(p);
        });
        var best = Object.keys(bins).map(function (k) { return bins[k]; })
          .sort(function (a, b) { return b.length - a.length; })[0];
        var avg = [0, 1, 2].map(function (k) {
          return Math.round(best.reduce(function (s, p) { return s + p[k]; }, 0) / best.length);
        });
        done('rgb(' + avg.join(',') + ')');
      } catch (e) { done(null); }
    };
    img.onerror = function () { done(null); };
    img.src = src;
  }
  function urlOf(str) {
    var m = str && str.match(/url\(["']?([^"')]+)["']?\)/);
    return m ? m[1] : null;
  }

  var SCOPES = '.product-section, quick-view-modal';

  /* Colour siblings (linked products) */
  function linked(dot) {
    if (dot.hasAttribute('data-offe-solid')) return;
    var bg = dot.getAttribute('style') || '';
    var src = urlOf(bg);
    if (!src) { dot.setAttribute('data-offe-solid', '1'); return; }
    dot.setAttribute('data-offe-solid', '0');
    var opt = dot.closest('.linked-products__option');
    var name = opt && opt.getAttribute('aria-label');
    if (!name) {
      var cur = dot.closest('.linked-products');
      var t = cur && cur.querySelector('.offe-color-name');
      name = t ? t.textContent.replace(/^[:\s]+/, '') : '';
    }
    if (name && name.indexOf(' - ') > -1) name = name.split(' - ').pop();
    var col = fromName(name);
    var paint = function (c) {
      if (c) dot.style.setProperty('background', c, 'important');
      dot.classList.add('offe-solid-dot');
      dot.setAttribute('data-offe-solid', '1');
    };
    if (col) paint(col); else sample(src.replace(/width=\d+/, 'width=96'), paint);
  }

  /* Colour variants that use the variant photo as the swatch */
  function variant(label) {
    if (label.hasAttribute('data-offe-solid')) return;
    var v = label.style.getPropertyValue('--swatch-color');
    var src = urlOf(v);
    if (!src) { label.setAttribute('data-offe-solid', '1'); return; }
    label.setAttribute('data-offe-solid', '0');
    var col = fromName(label.getAttribute('title') || '');
    var paint = function (c) {
      if (c) label.style.setProperty('--swatch-color', c);
      label.setAttribute('data-offe-solid', '1');
    };
    if (col) paint(col); else sample(src.replace(/width=\d+/, 'width=96'), paint);
  }

  function run() {
    document.querySelectorAll(SCOPES).forEach(function (scope) {
      scope.querySelectorAll('.linked-products:not(.linked-products--card) .linked-products__option-color').forEach(linked);
      scope.querySelectorAll('.product-form__controls--colors label.color-swatch').forEach(variant);
    });
  }
  function start() {
    run();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 50); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  OFFE - back-in-stock "Notify me" turned off (Rachel, Oct 28). Klaviyo's
  back-in-stock script hides the theme's "Sold Out" button (inline
  display:none !important) and puts its own "Notify me" button there. That
  button is hidden in offe-solid-swatches.css, so this puts the Sold Out
  button back whenever Klaviyo hides it. Remove this block (and the CSS rule)
  to bring Klaviyo's button back.
*/
(function () {
  function fix() {
    document.querySelectorAll('.product-form__submit[name="add"]').forEach(function (b) {
      if (b.style.getPropertyValue('display') === 'none') b.style.removeProperty('display');
    });
  }
  function start() {
    fix();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(fix, 30); })
      .observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  OFFE - sizes in the "Quick View" bar on product cards (Rachel, Oct 28):
  more space between sizes (14px), and when they don't fit on one line they
  wrap onto a second (or third) line instead of running off the side. The
  bar grows upward over the photo to fit. Desktop only (the size row is only
  laid over the bar from 1160px up). Works on the homepage rows, collection
  grids and the product page rows.
*/
(function () {
  var SEL = '.product-card__information-bottom .product-card__option-group[data-option-position]';
  // Speed (Oct 28): measures every card in a few batched passes (clear, read,
  // measure, write) instead of read/write per card, which made the browser
  // re-lay-out the page once per card. Cards already fitted are skipped
  // unless the window is resized.
  function fitAll(cards) {
    var items = [];
    cards.forEach(function (c) {
      var g = c.querySelector(SEL), q = c.querySelector('.product-card__quickview');
      if (g && q) items.push({ c: c, g: g, q: q });
    });
    if (!items.length) return;
    // 1. write: clear earlier fits
    items.forEach(function (o) {
      ['top', 'height'].forEach(function (p) { o.g.style.removeProperty(p); o.q.style.removeProperty(p); });
    });
    // 2. read: the bar's own size from the CSS
    items.forEach(function (o) {
      o.c.setAttribute('data-offe-fit2', '');
      var cs = getComputedStyle(o.g);
      if (cs.position !== 'absolute') return;
      o.top = parseFloat(cs.top); o.h = parseFloat(cs.height);
      var qs = getComputedStyle(o.q);
      o.qTop = parseFloat(qs.top); o.qH = parseFloat(qs.height);
      o.on = !!o.h;
    });
    items = items.filter(function (o) { return o.on; });
    // 3. write: spacing + wrapping, natural height for measuring
    items.forEach(function (o) {
      o.g.style.setProperty('column-gap', '14px', 'important');
      o.g.style.setProperty('row-gap', '2px', 'important');
      o.g.style.setProperty('flex-wrap', 'wrap', 'important');
      o.g.style.setProperty('align-content', 'center', 'important');
      o.g.style.setProperty('height', 'auto', 'important');
    });
    // 4. read: how tall the sizes need to be
    items.forEach(function (o) { o.need = o.g.scrollHeight + 10; });
    // 5. write: grow the bar upward where needed
    items.forEach(function (o) {
      o.g.style.removeProperty('height');
      if (o.need <= o.h) return;
      var extra = Math.ceil(o.need - o.h);
      o.g.style.setProperty('top', (o.top - extra) + 'px', 'important');
      o.g.style.setProperty('height', (o.h + extra) + 'px', 'important');
      o.q.style.setProperty('top', (o.qTop - extra) + 'px', 'important');
      o.q.style.setProperty('height', (o.qH + extra) + 'px', 'important');
    });
  }
  function cardsWithSizes(onlyNew) {
    var out = [];
    document.querySelectorAll('.product-card').forEach(function (c) {
      if (onlyNew && c.hasAttribute('data-offe-fit2')) return;
      if (c.querySelector(SEL)) out.push(c);
    });
    return out;
  }
  function all() { fitAll(cardsWithSizes(false)); }
  function fresh() { fitAll(cardsWithSizes(true)); }
  function start() {
    all();
    var t, r;
    new MutationObserver(function (muts) {
      // a card whose sizes were swapped (e.g. a colour dot) gets fitted again
      muts.forEach(function (m) {
        var c = m.target.closest && m.target.closest('.product-card[data-offe-fit2]');
        if (c) c.removeAttribute('data-offe-fit2');
      });
      clearTimeout(t); t = setTimeout(fresh, 150);
    })
      .observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', function () { clearTimeout(r); r = setTimeout(all, 150); });
    window.addEventListener('load', all);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  OFFE - Quick View: the product title links to the full product page
  (Rachel, Oct 28). Uses the same address as "View full details", so it
  follows colour switches inside Quick View too. Looks the same as before;
  underlines on hover.
*/
(function () {
  function link() {
    document.querySelectorAll('quick-view-modal .product__title').forEach(function (t) {
      var m = t.closest('quick-view-modal');
      var full = m && m.querySelector('a.product__full-details[href]');
      if (!full) return;
      var href = full.getAttribute('href');
      var a = t.querySelector('a.offe-qv-title');
      if (a) { if (a.getAttribute('href') !== href) a.setAttribute('href', href); return; }
      a = document.createElement('a');
      a.className = 'offe-qv-title';
      a.href = href;
      a.style.cssText = 'color:inherit;text-decoration:none;';
      a.addEventListener('mouseenter', function () { a.style.textDecoration = 'underline'; a.style.textUnderlineOffset = '4px'; });
      a.addEventListener('mouseleave', function () { a.style.textDecoration = 'none'; });
      while (t.firstChild) a.appendChild(t.firstChild);
      t.appendChild(a);
    });
  }
  function start() {
    link();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(link, 60); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  OFFE - "Final sale" on cart lines (Rachel, Oct 28). snippets/cart-item.liquid
  shows "Final sale · No returns or exchanges" under final-sale products (the
  product's custom.offe_final_sale metafield) and marks lines that don't yet
  carry the "Final sale" line-item property with a hidden .offe-fs-flag.
  This adds that property (keeping any others) so Shopify shows
  "Final sale: No returns or exchanges" under the item at checkout, in the
  order confirmation and in admin. Runs on page load and whenever the cart
  re-renders; a click on Checkout waits for it to finish.
*/
(function () {
  var busy = null;
  function fix() {
    if (busy) return busy;
    var flags = document.querySelectorAll('.offe-fs-flag');
    if (!flags.length) return Promise.resolve();
    var lines = {};
    flags.forEach(function (f) { lines[f.getAttribute('data-line')] = 1; });
    busy = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var before = cart.items.length;
        var chain = Promise.resolve();
        Object.keys(lines).map(Number).sort(function (a, b) { return a - b; }).forEach(function (line) {
          chain = chain.then(function () {
            var it = cart.items[line - 1];
            if (!it || (it.properties && it.properties['Final sale'])) return;
            var props = {};
            Object.keys(it.properties || {}).forEach(function (k) { props[k] = it.properties[k]; });
            props['Final sale'] = 'No returns or exchanges';
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ line: line, quantity: it.quantity, properties: props })
            }).then(function (r) { return r.json(); }).then(function (c) { if (c && c.items) cart = c; });
          });
        });
        return chain.then(function () {
          document.querySelectorAll('.offe-fs-flag').forEach(function (f) { f.remove(); });
          if (cart.items.length !== before) location.reload();
        });
      })
      .catch(function () {})
      .then(function () { busy = null; });
    return busy;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[name="checkout"]');
    if (!b || (!busy && !document.querySelector('.offe-fs-flag'))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fix().then(function () { window.location.href = '/checkout'; });
  }, true);
  function start() {
    fix();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { if (document.querySelector('.offe-fs-flag')) fix(); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
